import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faUsers } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, PageHeader,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import PageFilterModule from '@components/PageFilterModule'

import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'
import useUser, { generateUrls } from '@hooks/useUser'

import EnabledPermission from '@components/EnabledPermission'
import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import Agents from '../Agents'
import BrandUsers from '../BrandUsers'
import OfficeAdministrators from '../OfficeAdministrators'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Name, Email, Username or ID',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: { resetFilters, updateFilters },
  } = pageContext

  const { selectedAgencyId } = useAgencySelector()

  const { usersIndexUrl } = generateUrls({}, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  const {
    callbacks: { addUser },
  } = useUser(
    {
      association_id: selectedAgencyId,
      association_type: 'Agency',
    },
    {
      generateUrlsOptions: {
        prefixRoute: `agencies/${selectedAgencyId}/manage`,
      },
    },
  )

  const { currentUser } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Users | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <EnabledPermission permissionKey="admin.users.manage">
            <Button buttonStyle="primaryCreate" onClick={() => addUser()} size="medium">
              Create User
            </Button>
          </EnabledPermission>
        )}
        activeTabBarItemKey="users"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={[
          {
            href: usersIndexUrl,
            icon: faUsers,
            key: 'users',
            title: 'All Users',
          },
        ]}
        title="All Users"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.users.banner" />

            <Agents pageFilters={pageFilters} />

            <OfficeAdministrators pageFilters={pageFilters} />

            {currentUser.brand_user && <BrandUsers pageFilters={pageFilters} />}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.users.sidebar" />

            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
